import React, { useState, useEffect } from 'react';
import axios from 'axios';

const ImageManager = () => {
  const [carpetas, setCarpetas] = useState([]);
  const [carpetaSeleccionada, setCarpetaSeleccionada] = useState(null);
  const [imagenesCarpeta, setImagenesCarpeta] = useState([]);
  const [loading, setLoading] = useState(false);
  const [uploadingFile, setUploadingFile] = useState(false);
  const [mapeos, setMapeos] = useState([]);
  const [showMappings, setShowMappings] = useState(false);
  
  const [nuevoMapeo, setNuevoMapeo] = useState({
    destino: '',
    carpeta: ''
  });

  const API_URL = process.env.REACT_APP_API_URL || 'http://localhost:13000';
  const token = localStorage.getItem('token');

  const cargarCarpetas = async () => {
    setLoading(true);
    try {
      const response = await axios.get(`${API_URL}/api/admin/images/folders`, {
        headers: { Authorization: `Bearer ${token}` }
      });
      console.log('Respuesta carpetas:', response.data);
      console.log('Es array?:', Array.isArray(response.data));
      
      // Asegurar que sea array
      const data = Array.isArray(response.data) ? response.data : [];
      setCarpetas(data);
    } catch (error) {
      console.error('Error cargando carpetas:', error);
      setCarpetas([]);
    } finally {
      setLoading(false);
    }
  };

  const cargarImagenesCarpeta = async (nombreCarpeta) => {
    setLoading(true);
    try {
      const response = await axios.get(
        `${API_URL}/api/admin/images/folders/${nombreCarpeta}`,
        { headers: { Authorization: `Bearer ${token}` } }
      );
      const data = Array.isArray(response.data) ? response.data : [];
      setImagenesCarpeta(data);
      setCarpetaSeleccionada(nombreCarpeta);
    } catch (error) {
      console.error('Error cargando imágenes:', error);
      setImagenesCarpeta([]);
    } finally {
      setLoading(false);
    }
  };

  const subirImagen = async (e) => {
    const file = e.target.files[0];
    if (!file) return;

    if (!carpetaSeleccionada) {
      alert('Selecciona una carpeta primero');
      return;
    }

    const formData = new FormData();
    formData.append('image', file);
    formData.append('carpeta', carpetaSeleccionada);

    setUploadingFile(true);
    try {
      await axios.post(`${API_URL}/api/admin/images/upload`, formData, {
        headers: {
          Authorization: `Bearer ${token}`,
          'Content-Type': 'multipart/form-data'
        }
      });

      alert('✅ Imagen subida');
      cargarImagenesCarpeta(carpetaSeleccionada);
      cargarCarpetas();
    } catch (error) {
      console.error('Error subiendo imagen:', error);
      alert('❌ Error: ' + (error.response?.data?.error || error.message));
    } finally {
      setUploadingFile(false);
    }
  };

  const eliminarImagen = async (filename) => {
    if (!window.confirm(`¿Eliminar ${filename}?`)) return;

    try {
      await axios.delete(`${API_URL}/api/admin/images/delete`, {
        headers: { Authorization: `Bearer ${token}` },
        data: { carpeta: carpetaSeleccionada, filename }
      });

      alert('✅ Imagen eliminada');
      cargarImagenesCarpeta(carpetaSeleccionada);
      cargarCarpetas();
    } catch (error) {
      console.error('Error eliminando imagen:', error);
      alert('❌ Error eliminando imagen');
    }
  };

  const renumerarImagenes = async () => {
    if (!window.confirm('¿Renumerar imágenes?')) return;

    try {
      await axios.post(`${API_URL}/api/admin/images/renumber`, 
        { carpeta: carpetaSeleccionada },
        { headers: { Authorization: `Bearer ${token}` } }
      );

      alert('✅ Imágenes renumeradas');
      cargarImagenesCarpeta(carpetaSeleccionada);
    } catch (error) {
      console.error('Error renumerando:', error);
      alert('❌ Error renumerando');
    }
  };

  const cargarMapeos = async () => {
    try {
      const response = await axios.get(`${API_URL}/api/admin/images/mappings`, {
        headers: { Authorization: `Bearer ${token}` }
      });
      const data = Array.isArray(response.data) ? response.data : [];
      setMapeos(data);
    } catch (error) {
      console.error('Error cargando mapeos:', error);
      setMapeos([]);
    }
  };

  const crearMapeo = async () => {
    if (!nuevoMapeo.destino || !nuevoMapeo.carpeta) {
      alert('Completa ambos campos');
      return;
    }

    try {
      await axios.post(`${API_URL}/api/admin/images/mappings`, {
        destino_nombre: nuevoMapeo.destino,
        carpeta_imagenes: nuevoMapeo.carpeta
      }, {
        headers: { Authorization: `Bearer ${token}` }
      });

      alert('✅ Mapeo creado');
      setNuevoMapeo({ destino: '', carpeta: '' });
      cargarMapeos();
    } catch (error) {
      console.error('Error creando mapeo:', error);
      alert('❌ Error: ' + (error.response?.data?.error || error.message));
    }
  };

  const eliminarMapeo = async (id) => {
    if (!window.confirm('¿Eliminar mapeo?')) return;

    try {
      await axios.delete(`${API_URL}/api/admin/images/mappings/${id}`, {
        headers: { Authorization: `Bearer ${token}` }
      });

      alert('✅ Mapeo eliminado');
      cargarMapeos();
    } catch (error) {
      console.error('Error eliminando mapeo:', error);
      alert('❌ Error eliminando');
    }
  };

  useEffect(() => {
    cargarCarpetas();
    cargarMapeos();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <div className="p-6">
      <h1 className="text-2xl font-bold mb-6">🖼️ Gestor de Imágenes</h1>

      <div className="flex gap-4 mb-6 border-b">
        <button
          onClick={() => setShowMappings(false)}
          className={`px-6 py-3 font-semibold ${!showMappings ? 'text-teal-600 border-b-2 border-teal-600' : 'text-gray-600'}`}
        >
          📁 Carpetas
        </button>
        <button
          onClick={() => setShowMappings(true)}
          className={`px-6 py-3 font-semibold ${showMappings ? 'text-teal-600 border-b-2 border-teal-600' : 'text-gray-600'}`}
        >
          🔗 Asociar Destinos
        </button>
      </div>

      {!showMappings && (
        <div className="grid grid-cols-3 gap-6">
          <div className="bg-white rounded-lg shadow p-4">
            <h2 className="text-xl font-bold mb-4">Carpetas ({Array.isArray(carpetas) ? carpetas.length : 0})</h2>
            
            {loading ? (
              <p>Cargando...</p>
            ) : (
              <div className="space-y-2 max-h-96 overflow-y-auto">
                {Array.isArray(carpetas) && carpetas.map((carpeta) => (
                  <button
                    key={carpeta.nombre}
                    onClick={() => cargarImagenesCarpeta(carpeta.nombre)}
                    className={`w-full text-left p-3 rounded-lg ${
                      carpetaSeleccionada === carpeta.nombre ? 'bg-teal-100' : 'bg-gray-50'
                    }`}
                  >
                    <div className="font-semibold">{carpeta.nombre}</div>
                    <div className="text-sm text-gray-600">📷 {carpeta.cantidad} imágenes</div>
                  </button>
                ))}
              </div>
            )}
          </div>

          <div className="col-span-2 bg-white rounded-lg shadow p-4">
            {carpetaSeleccionada ? (
              <>
                <div className="flex justify-between mb-4">
                  <h2 className="text-xl font-bold">
                    {carpetaSeleccionada} ({Array.isArray(imagenesCarpeta) ? imagenesCarpeta.length : 0})
                  </h2>
                  <div className="flex gap-2">
                    <label className="bg-teal-600 text-white px-4 py-2 rounded-lg cursor-pointer hover:bg-teal-700">
                      {uploadingFile ? '⏳ Subiendo...' : '➕ Subir'}
                      <input
                        type="file"
                        accept="image/*"
                        onChange={subirImagen}
                        className="hidden"
                        disabled={uploadingFile}
                      />
                    </label>
                    <button
                      onClick={renumerarImagenes}
                      className="bg-blue-600 text-white px-4 py-2 rounded-lg hover:bg-blue-700"
                    >
                      🔢 Renumerar
                    </button>
                  </div>
                </div>

                <div className="grid grid-cols-3 gap-4 max-h-96 overflow-y-auto">
                  {Array.isArray(imagenesCarpeta) && imagenesCarpeta.map((img) => (
                    <div key={img.nombre} className="relative group">
                      <img
                        src={`${API_URL}${img.url}`}
                        alt={img.nombre}
                        className="w-full h-32 object-cover rounded-lg"
                        onError={(e) => {
                          e.target.src = '/images/placeholder.jpg';
                        }}
                      />
                      <div className="absolute bottom-0 left-0 right-0 bg-black bg-opacity-60 text-white text-xs p-2">
                        {img.nombre}
                      </div>
                      <button
                        onClick={() => eliminarImagen(img.nombre)}
                        className="absolute top-2 right-2 bg-red-600 text-white p-2 rounded-full opacity-0 group-hover:opacity-100"
                      >
                        🗑️
                      </button>
                    </div>
                  ))}
                </div>
              </>
            ) : (
              <div className="text-center text-gray-500 py-20">
                Selecciona una carpeta
              </div>
            )}
          </div>
        </div>
      )}

      {showMappings && (
        <div className="space-y-6">
          <div className="bg-white rounded-lg shadow p-6">
            <h2 className="text-xl font-bold mb-4">➕ Crear Asociación</h2>
            <div className="grid grid-cols-3 gap-4">
              <input
                type="text"
                placeholder="Nombre del destino"
                value={nuevoMapeo.destino}
                onChange={(e) => setNuevoMapeo({ ...nuevoMapeo, destino: e.target.value })}
                className="border rounded-lg px-4 py-2"
              />
              <select
                value={nuevoMapeo.carpeta}
                onChange={(e) => setNuevoMapeo({ ...nuevoMapeo, carpeta: e.target.value })}
                className="border rounded-lg px-4 py-2"
              >
                <option value="">Selecciona carpeta...</option>
                {Array.isArray(carpetas) && carpetas.map((c) => (
                  <option key={c.nombre} value={c.nombre}>
                    {c.nombre} ({c.cantidad} imgs)
                  </option>
                ))}
              </select>
              <button
                onClick={crearMapeo}
                className="bg-teal-600 text-white px-6 py-2 rounded-lg hover:bg-teal-700"
              >
                Crear
              </button>
            </div>
          </div>

          <div className="bg-white rounded-lg shadow p-6">
            <h2 className="text-xl font-bold mb-4">
              🔗 Asociaciones ({Array.isArray(mapeos) ? mapeos.length : 0})
            </h2>
            <div className="overflow-x-auto">
              <table className="w-full">
                <thead className="bg-gray-50">
                  <tr>
                    <th className="px-4 py-2 text-left">Destino</th>
                    <th className="px-4 py-2 text-left">Carpeta</th>
                    <th className="px-4 py-2 text-center">Imágenes</th>
                    <th className="px-4 py-2 text-center">Acciones</th>
                  </tr>
                </thead>
                <tbody>
                  {Array.isArray(mapeos) && mapeos.map((mapeo) => (
                    <tr key={mapeo.id} className="border-b hover:bg-gray-50">
                      <td className="px-4 py-3">{mapeo.destino_nombre}</td>
                      <td className="px-4 py-3">
                        <span className="bg-teal-100 px-2 py-1 rounded text-sm">
                          {mapeo.carpeta_imagenes}
                        </span>
                      </td>
                      <td className="px-4 py-3 text-center">{mapeo.cantidad_imagenes}</td>
                      <td className="px-4 py-3 text-center">
                        <button
                          onClick={() => eliminarMapeo(mapeo.id)}
                          className="text-red-600 hover:text-red-800"
                        >
                          🗑️
                        </button>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default ImageManager;